export const round = (num: number, decimalPlaces: number): number =>
  Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
export const floor = (num: number, decimalPlaces: number): number =>
  Math.floor(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
export const calculatePercentage = (value: number, total: number): number =>
  Math.floor((value / total) * 100);
